import { render, staticRenderFns } from "./DirectaButton.vue?vue&type=template&id=327f0857"
import script from "./DirectaButton.vue?vue&type=script&lang=js"
export * from "./DirectaButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports